var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import { Route, Switch } from "react-router-dom";
import Categories from "./categories";
import Resources from "./resources";
import ResourceEdit from "./resourceEdit";
import ResourceDetails from "./resource";
import { SEOTitleContextProvider, } from "../../src/View/UI/SEO/SEO";
const getResourceTitle = (title, info) => __awaiter(void 0, void 0, void 0, function* () { return title ? `${title} - ${info.name}` : info.name; });
class ResourceGuide extends PureComponent {
    render() {
        return (_jsx(SEOTitleContextProvider, { makeTitle: getResourceTitle, children: _jsxs(Switch, { children: [_jsx(Route, { component: Categories, path: "/aviso/app/resourceGuide/index" }), _jsx(Route, { component: ResourceEdit, path: "/aviso/app/resourceGuide/category/:categoryId/resource/:resourceId?/edit" }), _jsx(Route, { component: ResourceDetails, path: "/aviso/app/resourceGuide/category/:categoryId/resource/:resourceId/details" }), _jsx(Route, { component: ResourceEdit, path: "/aviso/app/resourceGuide/category/:categoryId/resource/create" }), _jsx(Route, { component: Resources, path: "/aviso/app/resourceGuide/category/:categoryId" })] }) }));
    }
}
export default ResourceGuide;
